import { fetchSettings } from '@esentai/core/features/applicationSettings/actions';
import withAsyncRunner from '@esentai/core/hocs/withAsyncRunner';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import { updateContacts } from '@/features/contactsEditPage/actions';

import EditContacts from './component';

const mapDispatchToProps = { fetchSettings, updateContacts };

export default compose(
  connect(null, mapDispatchToProps),
  withAsyncRunner({ runnerMethod: 'fetchSettings' }),
)(EditContacts);
